var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSimImageActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.5,125.8,646.7,67.4A32,32,0,0,0,632.4,64H199.5a32,32,0,0,0-14.3,3.4L68.4,125.8A8.15,8.15,0,0,0,64,133V312a8,8,0,0,0,8,8H192V696a8,8,0,0,0,8,8H431.9l24-64H393l14.9-64,104-64,128-64h.1V320H760a8,8,0,0,0,8-8V132.9A8.17,8.17,0,0,0,763.5,125.8ZM415.9,256a128.12,128.12,0,0,1-128-128h256A128.12,128.12,0,0,1,415.9,256Z",
    style: {
      fill: "#006eff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.62,398.93,613,634.57V960H549V633.07L443.38,398.93l22.43-12.82a16,16,0,0,1,7.94-2.11h217.5a16,16,0,0,1,7.94,2.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.48,440.47a16,16,0,0,0-6.87-7.83L699.2,386.11a16,16,0,0,0-7.94-2.11H473.76a16,16,0,0,0-7.94,2.11L384.4,432.64a16,16,0,0,0-6.34,6.67L376,440l54.51,40L480,448H680l54.51,32,48.91-39.53Z",
    style: {
      fill: "#a3d7ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549,633.07V960H366.5a8,8,0,0,1-8-8V928.26L210.14,871.2a8,8,0,0,1-4.53-10.49L377.53,440.47a16,16,0,0,1,6.87-7.83l59-33.71Z",
    style: {
      fill: "#a3d7ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954.87,871.2,806.5,928.26V952a8,8,0,0,1-8,8H613V634.57L721.62,398.93l59,33.71a16,16,0,0,1,6.87,7.83L959.4,860.71A8,8,0,0,1,954.87,871.2Z",
    style: {
      fill: "#a3d7ff"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimImageActive);
export default __webpack_public_path__ + "static/media/sim_image_active.6608a353cc65c8dab82647a380a86690.svg";
export { ForwardRef as ReactComponent };